// Instance
import MainAPI from "@/app/apis/main/main-api.js"

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js"

// Query String
const queryString = require("querystring")

class PuppySellAPI extends MainAPI {
	/**
	 * @return Object
	 */
	async savePuppyDetails(puppyDetails) {
		let newFormData = new FormData()
		newFormData.append("formData", JSON.stringify(puppyDetails.formData))

		if (puppyDetails.images.length > 0) {
			puppyDetails.images.forEach((image) => {
				newFormData.append("images", image)
			})
		}

		return API.post(`${ENDPOINTS.POST_PUPPY_SELL_REQUEST}`, newFormData, {
			header: {
				"Content-Type": "multipart/form-data",
			},
		})
	}

	async getPuppySellDetails(puppySellId) {
		return API.get(`${ENDPOINTS.GET_PUPPY_SELL}/${puppySellId}`)
	}

	async processUserActivationAndPuppyDetails(referenceNumber) {
		return API.post(`${ENDPOINTS.POST_ACTIVATE_USER}?f_referenceNumber=${referenceNumber}`)
	}

	async getUserPuppySellList(queryParams) {
		return API.get(`${ENDPOINTS.GET_PUPPY_SELL}/request/list?${queryString.stringify(queryParams)}`)
	}

	async updateUserPuppyDetails(puppyDetails) {
		let newFormData = new FormData()
		newFormData.append("formData", JSON.stringify(puppyDetails.formData))

		if (puppyDetails.images.length > 0) {
			puppyDetails.images.forEach((image) => {
				newFormData.append("images", image)
			})
		}

		return API.put(`${ENDPOINTS.PUT_PUPPY_SELL}/details/update`, newFormData)
	}

	async getAllApprovedPuppySellList(queryParams) {
		return API.get(`${ENDPOINTS.GET_PUPPY_SELL}/approved/list?${queryString.stringify(queryParams)}`)
	}

	async getPuppySellDetailsById(puppyDetails) {
		return API.get(`${ENDPOINTS.GET_PUPPY_SELL}?${queryString.stringify(puppyDetails)}`)
	}

	async purchasePuppyVerify(verifyDetails) {
		return API.post(`${ENDPOINTS.POST_PUPPY_PURCHASE_VERIFY}`, verifyDetails)
	}

	async purchasePuppyVerifyPlus(verifyDetails) {
		return API.post(`${ENDPOINTS.POST_PUPPY_PURCHASE_VERIFY_PLUS}`, verifyDetails)
	}

	/**
	 * @return {object} Latitude Link Redirection
	 * @param {*} paymentDetails - Payment Details
	 */

	async puppyCheckoutWithLpCard(paymentDetails) {
		return API.post(`${ENDPOINTS.POST_LATITUDE_PAY_CARD_CHECKOUT}`, paymentDetails)
	}

	async sendEmailPuppyPurchase(details) {
		return API.post(`${ENDPOINTS.POST_LATITUDE_SEND_EMAIL}`, details)
	}

	async getPuppyPurchase(details) {
		return API.post(`${ENDPOINTS.GET_PUPPY_PURCHASE}`, details)
	}

	async reapprovedPuppyDetails(puppyDetails) {
		let newFormData = new FormData()
		newFormData.append("formData", JSON.stringify(puppyDetails.formData))

		if (puppyDetails.images.length > 0) {
			puppyDetails.images.forEach((image) => {
				newFormData.append("images", image)
			})
		}

		return API.put(`${ENDPOINTS.PUT_PUPPY_SELL}/details/re-approved`, newFormData)
	}

	async getPuppyPurchasedList(queryParams) {
		return API.get(
			`${ENDPOINTS.GET_PUPPY_SELL}${ENDPOINTS.GET_PUPPY_PURCHASE_HISTORY}/list?${queryString.stringify(
				queryParams
			)}`
		)
	}

	async getPuppyPurchasedDescription(puppyId) {
		return API.get(`${ENDPOINTS.GET_PUPPY_SELL}${ENDPOINTS.GET_PUPPY_PURCHASE_HISTORY}/${puppyId}`)
	}

	async postPuppyRequestRefund(details) {
		return API.post(`${ENDPOINTS.POST_PUPPY_SELL_REQUEST_REFUND}`, details)
	}

	async putDeletePuppyToSell(puppySellId) {
		return API.put(`${ENDPOINTS.PUT_PUPPY_SELL}/delete/${puppySellId}`)
	}

	async cancelPuppyPurchase(puppyPurchaseId) {
		return API.put(`${ENDPOINTS.PUT_PUPPY_PURCHASE}/cancel/${puppyPurchaseId}`)
	}

	async updatePuppyDetailsStatus(puppySellId, details) {
		return API.put(`${ENDPOINTS.PUT_PUPPY_SELL}/status/update/${puppySellId}`, details)
	}

	async getPuppyPurchaseDetailsPayment(queryParams) {
		return API.get(`${ENDPOINTS.GET_PUPPY_PURCHASE}/payment?${queryString.stringify(queryParams)}`)
	}
}

export default new PuppySellAPI()
